module.exports = __webpack_public_path__ + "fb607ff0/img/logo_sourcery.7258796c.svg";